import { render, staticRenderFns } from "./PartnerChurnDiagram.vue?vue&type=template&id=7f54c360&"
import script from "./PartnerChurnDiagram.vue?vue&type=script&lang=js&"
export * from "./PartnerChurnDiagram.vue?vue&type=script&lang=js&"
import style0 from "./PartnerChurnDiagram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
